import { createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../../api/services/user";

export const getAdminUserInfo = createAsyncThunk(
  "user/get-admin-user-info",
  async () => {
    return await userService.getAdminUserInfo();
  }
);
